module.exports = __webpack_public_path__ + "static/img/13.ab761db.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/zh/13.png
// module id = qOxH
// module chunks = 0